<template>
  <div class="wb-grid-row owc-feature-stage-slider">
    <div class="wb-grid-col-mq1-12 wb-grid-col-mq4-9 wb-grid-col-mq5-7">
      <FeatureSlider :isDarkMode="isDarkMode">
        <div class="owc-feature-stage-slider__item" v-for="(item, index) in featureStageItems" :key="index">
          <div
            class="owc-feature-stage-slider__specification-box"
            :class="{
              'owc-feature-stage-slider__specification-box--dark': isDarkMode,
            }"
          >
            <span class="wb-type-label">{{ item.subline }}</span>
            <div
              class="owc-feature-stage-slider__number-specs"
              :class="{
                'owc-feature-stage-slider__number-specs--no-subline': !item.subline,
              }"
            >
              <span class="owc-feature-stage-slider__number-element">
                {{ item.numberElement }}
              </span>
              <span class="owc-feature-stage-slider__suffix-element">
                {{ item.numberSuffix }}
              </span>
            </div>
            <span class="wb-type-hint owc-feature-stage-slider__description" v-html="item.description"></span>
          </div>
        </div>
      </FeatureSlider>
    </div>
    <div class="wb-grid-col-mq1-12 wb-grid-col-mq4-3 wb-grid-col-mq5-5 owc-feature-stage-slider__cta-buttons">
      <slot />
    </div>
  </div>
</template>
<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { FeatureStageItem } from './FeatureStageItem';
import FeatureSlider from './FeatureSlider.vue';
export default ComponentInitializeDispatcher.extend({
  name: 'owc-feature-stage-slider',
  props: {
    stageSliderData: {
      type: Object,
    },
  },
  components: { FeatureSlider },
  computed: {
    isDarkMode: function(): boolean {
      return Boolean(this.stageSliderData?.darkMode);
    },
    featureStageItems(): FeatureStageItem[] {
      return this.stageSliderData?.featuredItems || [];
    },
  },
});
</script>
<style lang="scss">
$featureStageSlideModuleName: 'owc-feature-stage-slider';
.#{$featureStageSlideModuleName} {
  $feature-stage-slider-item-width: 204px;
  $feature-stage-slider-item-height: 116px;
  $feature-stage-slider-item-width-mq-4: 206px;
  $feature-stage-slider-item-height-mq-4: 136px;
  $feature-stage-slider-item-spacing: 8px;
  $feature-specification-box-opacity-mq4: 0.7;
  // taken from: https://git.i.mercedes-benz.com/dh-io-mbmxp/workbench/core/blob/develop/src/scss/utility/_typography.scss#L381
  $feature-stage-slider-item-subline-height: wb-pixel-to-rem(24px);

  align-items: flex-end;
  padding: var(--wb-spacing-s) 0 var(--wb-spacing-m);

  &__specification-box {
    display: flex;
    flex: 0 0 $feature-stage-slider-item-width;
    flex-direction: column;
    min-width: $feature-stage-slider-item-width;
    height: $feature-stage-slider-item-height;
    padding: var(--wb-spacing-xxs) var(--wb-spacing-xs) var(--wb-spacing-xs);
    overflow: hidden;

    color: var(--wb-grey-40);

    background-color: var(--wb-grey-90);

    @include wb-border-rounded-m;
    @include breakpoint-from(mq4) {
      min-width: $feature-stage-slider-item-width-mq-4;
      height: $feature-stage-slider-item-height-mq-4;

      background-color: rgba($wb-grey-90, $feature-specification-box-opacity-mq4);
    }
  }
  &__specification-box--dark {
    color: var(--wb-grey-60);

    background-color: var(--wb-grey-15);

    @include breakpoint-from(mq4) {
      background-color: rgba($wb-grey-15, $feature-specification-box-opacity-mq4);
    }
  }
  &__number-specs {
    display: flex;
    flex-direction: row;
    align-items: baseline;

    color: var(--wb-black);

    &--no-subline {
      margin-top: $feature-stage-slider-item-subline-height;
    }
  }
  &__specification-box--dark &__number-specs {
    color: var(--wb-white);
  }
  &__number-element {
    @include wb-type-heading-l;
  }
  &__suffix-element {
    margin-left: var(--wb-spacing-xxs);

    @include wb-type-heading-m;
  }
  &__description {
    margin-top: auto;
    padding-top: var(--wb-spacing-xxs);
  }
  &__item:not(:first-child) {
    margin-left: $feature-stage-slider-item-spacing;
  }
  &__cta-buttons {
    display: flex;

    @include breakpoint-between(mq4, mq5) {
      width: auto;
    }
  }
}
</style>
